import React, { useContext, useState } from 'react'
import styles from './CompanyNameWithPeriod.module.css'
import { FormTitle } from '../../../../Common/FormTitle'
import { NextButton } from '../../../../Common/CtaButton/NextButton'
import { StepContext } from '../../../StepContainer'
import { useAbTestGtm } from '../../../../../hooks/useAbTestGtm'
import { CompanyNameFields } from './CompanyNameFields'

export const JobSeekerCompanyNameOnly = () => {
    const { dataClickLabel, dataViewLabel } = useAbTestGtm()
    const { formState } = useContext(StepContext)

    const [companyName, setCompanyName] = useState(formState.userResumesAttributes[0]?.companyName || '')
    const [brandName, setBrandName] = useState(formState.userResumesAttributes[0]?.brandName || '')
    const [storeName, setStoreName] = useState(formState.userResumesAttributes[0]?.storeName || '')

    const isFormValid = companyName.trim() !== '' && brandName.trim() !== ''

    return (
        <div className={styles.wrapper}>
            <div className={styles.selectionWrapper}>
                <div className={styles.monthbox}>
                    <FormTitle
                        formTitleText='直近の会社名・店舗名は？'
                        dataViewLabel={dataViewLabel('EF_StepForm_会社名')}
                        dataClickLabel={dataClickLabel('EF_StepForm_会社名-戻る')}
                    />
                </div>
                <CompanyNameFields
                    companyName={companyName}
                    brandName={brandName}
                    storeName={storeName}
                    setCompanyName={setCompanyName}
                    setBrandName={setBrandName}
                    setStoreName={setStoreName}
                />
                <div className={styles.noticeBox}>
                    <div className={styles.noticeTitle}>
                        <img
                            src='/foodslaboEf/img/step6/orange_light_bulb.png'
                            alt='電球アイコン'
                            className={styles.noticeTitleIcon}
                        />
                        <span className={styles.noticeTitleText}>登録後、企業ブロックができます</span>
                    </div>
                    <div className={styles.noticeBody}>
                        <p className={styles.noticeBodyMain}>
                            マイページで企業をブロックすると、<br />
                            該当企業にはあなたの情報が表示されなくなります。
                        </p>
                        <p className={styles.noticeBodySub}>
                            （フーズラボ利用企業のみ）
                        </p>
                    </div>
                </div>

                <NextButton
                    formKey={[
                        'userResumesAttributes',
                        'companyName',
                        'brandName',
                        'storeName',
                    ]}
                    formValue={[
                        0,
                        companyName,
                        brandName,
                        storeName,
                    ]}
                    displayFormKey={['companyName', 'brandName', 'storeName']}
                    displayFormValue={[
                        companyName,
                        brandName,
                        storeName,
                    ]}
                    isDisabled={!isFormValid}
                    dataClickLabel={dataClickLabel('EF_StepForm_会社名-次へ')}
                />
            </div>
        </div>
    )
}
